<template>
  <ax-dialog 
    ref="dialog"
    title="Generate Report" 
    subtitle="Organize groups into report sections by dragging and dropping them between the lists."
    icon="mdi-export" 
    tooltip="Generate Report"
    persistent
    size="medium" 
    :disabled="disabled"
    @shown="onShown"
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text>
        <v-row>
          <v-col class="d-flex flex-column">
            <h5>Available Groups</h5>
            <v-chip-group column class="flex-grow-1 grey lighten-4 rounded pa-2">
              <draggable :list="source" group="groups" class="flex-grow-1">
                <v-chip v-for="(group, index) in source" :key="index">
                  {{ group.name }} ({{ group.count }} wells)
                  <v-icon right v-if="group.curves">mdi-approximately-equal</v-icon>
                </v-chip>
              </draggable>
            </v-chip-group>
          </v-col>
          <v-col class="d-flex flex-column">
            <h5>Selected Groups</h5>
            <v-chip-group column class="flex-grow-1 grey lighten-4 rounded pa-2">
              <draggable :list="target" group="groups" class="flex-grow-1">
                <v-chip v-for="(group, index) in target" :key="index">
                  {{ group.name }} ({{ group.count }} wells)
                  <v-icon right v-if="group.curves">mdi-approximately-equal</v-icon>
                </v-chip>
              </draggable>
            </v-chip-group>
          </v-col>
        </v-row>
        <!-- <v-autocomplete v-model="columns.selected" :items="columns.options" label="Available columns" multiple small-chips clearable></v-autocomplete>
        <v-checkbox v-model="summary" disabled label="Include overall summary (one group per line)" hide-details></v-checkbox>
        <v-checkbox v-model="aggregates" disabled label="Include group details (each group aggregated by year)" hide-details></v-checkbox>
        <v-checkbox v-model="individuals" disabled label="Include individual wells (one well per line)" hide-details></v-checkbox>
        <v-checkbox v-model="first_year" disabled label="Include first 12 months of each well" hide-details></v-checkbox>
        <v-checkbox v-model="charts" disabled label="Include GOR charts (for both group and wells)" hide-details></v-checkbox> -->
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
import Draggable from "vuedraggable"
export default {
  name: "dlgRunEconomics",
  props: {
    groups: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  components: {
    AxDialog, Draggable
  },
  data() {
    return {
      drag: false,
      source: [],
      target: [],
      summary: true,
      aggregates: true,
      individuals: true,
      first_year: true,
      charts: true,
      columns: {
        selected: [],
        options: [
          { text: 'Year', value: 'Year' },
          { text: 'Month', value: 'Month' },
          { text: 'Gross Oil (BBL)', value: 'gross_oil' },
          { text: 'Gross Gas (MCF)', value: 'gross_gas' },
          { text: 'Gross BOE', value: 'gross_boe' },
          { text: 'Net Oil (BBL)', value: 'net_oil' },
          { text: 'Net Gas (MCF)', value: 'net_gas' },
          { text: 'Oil Revenue ($)', value: 'oil_revenue' },
          { text: 'Gas Revenue ($)', value: 'gas_revenue' },
          { text: 'Gross Revenue ($)', value: 'gross_revenue' },
          { text: 'Operating Expenses ($)', value: 'operating_expenses' },
          { text: 'Severance Tax ($)', value: 'severance_tax' },
          { text: 'Ad Valorem Tax ($)', value: 'ad_valorem_tax' },
          { text: 'BFIT Cash Flow ($)', value: 'bfit_cash_flow' },
          { text: 'Net Income ($)', value: 'net_income' }
        ]
      }
    }
  },
  methods: {
    onShown() {
      let groups = JSON.parse(JSON.stringify(this.groups))
      groups = groups.map(g => ({ id: g.id, name: g.name, count: g.count, curves: this.isEmpty(g.curves) ? false : true }))
      this.source = groups
      this.target = []
    },
    onSubmit() {
      if (this.target.length == 0) {
        this.notify('Please select at least one group to include in the report', "red")
        return
      }
      this.$emit('submitted', this.target.map(g => g.name))
      this.$refs.dialog.show = false
    }
  }
}
</script>